var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solarTerms"},[(_vm.xData.length)?_c('div',{staticClass:"line-container"},[_c('div',{ref:"lineCharts",staticClass:"myCharts line-chart"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }